
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { User } from '../models/user.model';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class UsersMappingService {
    private _authService: AuthService;
    private basePath = "api/UserMapping";
    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    getAllUsers() {
        return this.http.get(`${this.basePath}/GetAllUsers/`, this.getAuthHeader(true));
    }

    getCustomersByUserId(customerUserId: string) {
        const data = { customerUserIds: customerUserId };
        return this.http.post(`${this.basePath}/GetCustomersByUserId/`, data, this.getAuthHeader(true));
    }

    getLinkedUserMappingGroup(SuperiorId: string) {
        return this.http.get(`${this.basePath}/GetLinkedUserMappingGroup/` + SuperiorId, this.getAuthHeader(true));
    }

    getSourceUsersForMapping(SuperiorId: string) {
        return this.http.get(`${this.basePath}/GetSourceUsersForMapping/` + SuperiorId, this.getAuthHeader(true));
    }

    getTargetUsersForMapping(SuperiorId: string) {
        return this.http.get(`${this.basePath}/GetTargetUsersForMapping/` + SuperiorId, this.getAuthHeader(true));
    }

    updateUserMappingGroup(SuperiorId: string, targetUsers: User[]) {
        const data = {
            SuperiorId: SuperiorId,
            targetUsers: targetUsers,
        };
        return this.http.post(`${this.basePath}/UpdateUserMappingGroup`, data, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        const options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/users-mapping.service.ts